import AivatarClient from '../AivatarClient'
import { PaginationParams } from '../types'

export async function getVideoExportList(workspaceId: number, params: PaginationParams) {
  const response = await AivatarClient().get(`/movies/workspace/${workspaceId}`, { params })

  return response.data
}

export const dummy = null
